import { useTranslation } from 'react-i18next'

import { ProgramDetailTable } from './Shared/ProgramDetailTable'
import { ComplianceCheck } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'
import { Flex, Typography } from '@percent/lemonade'

export function ProgramComplianceDetails({ failingFlags, flags }: ComplianceCheck) {
  const { t } = useTranslation()

  if (!failingFlags.length && !flags.length) return null

  return (
    <Flex gap={16} direction="column">
      <Typography variant="h4">{t('typography.compliance')}</Typography>
      <ProgramDetailTable
        title={t('program.label.flags')}
        items={flags.map(flag => t(`program.label.flags.${flag}`))}
      />
      <ProgramDetailTable
        title={t('program.label.failingFlags')}
        items={failingFlags.map(flag => t(`program.label.flags.${flag}`))}
      />
    </Flex>
  )
}
